<ng-container *fcHasPermission="'fc_dvr_settings'; else noPermission">
  @if (settingsLoading()) {
    <div class="h-full p-24 flex flex-col gap-22">
      @for (_ of skeletonRows; track $index) {
        <div class="flex gap-[5%]">
          <fc-skeleton shape="text" width="16px" height="16px"></fc-skeleton>
          <fc-skeleton shape="text" height="16px" width="20%"></fc-skeleton>
          <fc-skeleton shape="text" height="16px" width="20%"></fc-skeleton>
          <fc-skeleton shape="text" height="16px" width="20%"></fc-skeleton>
          <fc-skeleton shape="text" height="16px" width="20%"></fc-skeleton>
          <fc-skeleton shape="text" height="16px" width="20%"></fc-skeleton>
        </div>
      }
    </div>
  } @else {
    <div class="dvr-settings-table-container">
      @if (!noData) {
        <div class="overflow-x-auto">
          <div class="min-w-[900px]">
            <div
              class="grid w-full items-center border-b border-secondary-100 bg-secondary-50 h-40"
              [style.grid-template-columns]="tableColumns"
            >
              <div class="flex items-center justify-center">
                <fc-checkbox
                  (checkedChange)="toggleAll()"
                  [checked]="allSelected"
                  [indeterminate]="someSelected && !allSelected"
                />
              </div>
              <div class="text-xs text-grey-600 px-16">Vehicle</div>
              <div class="text-xs text-grey-600 px-16 flex items-center gap-4">
                Orientation
                <div #orientationInfo class="inline-flex">
                  <fc-icon icon="icon-info-circle" [size]="16"></fc-icon>
                </div>
                <fc-tooltip [target]="orientationInfo" position="top">
                  The DVR can be vertically aligned or upside down.
                </fc-tooltip>
              </div>
              <div class="text-xs text-grey-600 px-16">Bump sensitivity</div>
              <div class="text-xs text-grey-600 px-16 flex items-center gap-4">
                ICA
                <div #icaInfo class="inline-flex">
                  <fc-icon icon="icon-info-circle" [size]="16"></fc-icon>
                </div>
                <fc-tooltip [target]="icaInfo" position="top">
                  Inside camera access
                </fc-tooltip>
              </div>
              <div class="text-xs text-grey-600 px-16">Inside camera</div>
              <div class="text-xs text-grey-600 px-16">Resolution</div>
            </div>

            @for (element of pagedData(); track element.vehicle.id) {
              <div
                class="grid w-full items-center border-b border-secondary-100 hover:bg-secondary-50 h-64 group"
                [class.bg-secondary-50]="element.vehicle.enabled"
                [style.grid-template-columns]="tableColumns"
              >
                <div class="flex items-center justify-center">
                  @if (element.isPending) {
                    <mat-spinner [diameter]="25"></mat-spinner>
                  } @else {
                    <fc-checkbox
                      (checkedChange)="toggleItem(element)"
                      [checked]="element.vehicle.enabled"
                    />
                  }
                </div>
                <div class="px-16">
                  <fc-vehicle-small-item
                    [vehicle]="element.vehicle"
                    [groups]="getVehicleGroups(element.vehicle)"
                  />
                </div>
                <div class="px-16 text-sm">
                  {{ element.orientation | titlecase }}
                </div>
                <div class="px-16 text-sm">
                  {{ element.bump_sensitivity | titlecase }}
                </div>
                <div class="px-16">
                  @if (element.insideCameraAccess) {
                    <fc-status-tag text="On" color="#19C98A"></fc-status-tag>
                  } @else {
                    <fc-status-tag text="Off" color="#78909C"></fc-status-tag>
                  }
                </div>
                <div class="px-16">
                  @if (element.inside_camera) {
                    <fc-status-tag text="On" color="#19C98A"></fc-status-tag>
                  } @else {
                    <fc-status-tag text="Off" color="#78909C"></fc-status-tag>
                  }
                </div>
                <div
                  class="px-16 flex items-center justify-between relative min-h-32 pr-40"
                >
                  <div>{{ element.resolution }}</div>
                  @if (!element.isPending) {
                    <div
                      class="absolute right-24 opacity-0 invisible pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto"
                    >
                      <fc-button
                        icon="icon-edit"
                        variant="text"
                        color="secondary"
                        [iconOnly]="true"
                        size="sm"
                        (click)="openEditDvrSettings(element)"
                      />
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="flex justify-center items-center h-[60vh]">
          <fc-empty-state
            title="No items found"
            subtitle="Try different settings"
          ></fc-empty-state>
        </div>
      }
      <mat-paginator
        class="table-paginator"
        [class.hidden]="noData"
        [length]="dataSource.data.length"
        [pageSizeOptions]="[5, 10, 25, 50]"
        [pageSize]="50"
        aria-label="Select page"
      />
    </div>
  }
</ng-container>

<ng-template #noPermission>
  <div class="flex justify-center items-center h-[60vh]">
    <fc-empty-state
      icon="icon-empty_state_no_access"
      title="No Access"
      subtitle="Required feature is not available for your account."
    ></fc-empty-state>
  </div>
</ng-template>
